import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { Router } from '@angular/router';
import AirdropTask from '../../models/AirdropTask';

@Component({
    selector: 'app-airdrop-lend',
    templateUrl: './airdrop-lend.component.html',
    styleUrls: [ './airdrop-lend.component.scss' ]
})
export class AirdropLendComponent implements OnInit {
    @Input() task = new AirdropTask();

    constructor(public httpService: HttpService,
        private router: Router
    ) {
        this.window = getWindow();
    }

    window: Window;

    ngOnInit(): void {
        this.attachSocketEvents();
    }

    attachSocketEvents() {

    }
    
    lendPusd() {
        this.router.navigate([ '/lend' ]);
    }
}
